module.exports = __webpack_public_path__ + "img/frame09_normal.15d79ab8.png";